import { useEffect } from "react";
import { setIsAutoplayEnabled } from "@/utils";
import { AppProperties } from "@/api";

export const useInitializeLocalStorage = (properties?: AppProperties) => {
  useEffect(() => {
    const autoPlayLocalStorage = localStorage.getItem("autoplay");

    if (properties && !autoPlayLocalStorage) {
      setIsAutoplayEnabled(properties.AutoPlayDefault !== "0");
    }
  }, [properties]);
};
